var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupLabelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257,
    height: 159,
    viewBox: "0 0 257 159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65922",
    "data-name": "Group 65922",
    transform: "translate(-1545 -389)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16464",
    "data-name": "Rectangle 16464",
    width: 257,
    height: 159,
    transform: "translate(1545 389)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16466",
    "data-name": "Rectangle 16466",
    width: 79,
    height: 89,
    transform: "translate(1693 429)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_13",
    "data-name": "Polygon 13",
    d: "M47.5,0,95,82H0Z",
    transform: "translate(1619 436)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16467",
    "data-name": "Rectangle 16467",
    width: 73,
    height: 73,
    rx: 36.5,
    transform: "translate(1575 445)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16468",
    "data-name": "Rectangle 16468",
    transform: "translate(1564 436)",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1,
    strokeDasharray: 6,
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 88,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 94,
    height: 87,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pointer-svgrepo-com_1_",
    "data-name": "pointer-svgrepo-com (1)",
    transform: "translate(1615.54 514.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67691",
    "data-name": "Path 67691",
    d: "M37.16,7.332A5.633,5.633,0,1,1,48.1,9.217l1.6.569A7.332,7.332,0,1,0,40.229,14.2l.594-1.592A5.659,5.659,0,0,1,37.16,7.332Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67692",
    "data-name": "Path 67692",
    d: "M89.961,51.7a2.8,2.8,0,0,1,2.8,2.8c0,.014,0,.028,0,.043v.036l1.7.047V54.6c0-.033,0-.067,0-.1a4.5,4.5,0,1,0-7.294,3.524l1.057-1.331A2.8,2.8,0,0,1,89.961,51.7Z",
    transform: "translate(-47.168 -47.167)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67693",
    "data-name": "Path 67693",
    d: "M164.89,129.43V146.6l5.134-6.164,8.022.029Z",
    transform: "translate(-122.098 -122.098)",
    fill: "#777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupLabelIcon);
export default __webpack_public_path__ + "static/media/groupLabelIcon.37dfe05631e443ba41d05c749b01fb47.svg";
export { ForwardRef as ReactComponent };